import { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';
import { Switch } from '@/components/ui/switch';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/ui/form';

const TimePicker = ({ name, description, label, className, ...rest }) => {
  const form = useFormContext();
  const [hours, setHours] = useState('');
  const [minutes, setMinutes] = useState('00');
  const [isPM, setIsPM] = useState(false);

  const updateTime = (newHours, newMinutes, newIsPM) => {
    const h = newIsPM ? (newHours % 12) + 12 : newHours % 12;
    form.setValue(name, `${h.toString().padStart(2, '0')}:${newMinutes}`);
  };

  useEffect(() => {
    const value = form.getValues(name);
    if (value) {
      setHours(parseInt(value.split(':')[0]) % 12 || 12);
      setMinutes(value.split(':')[1]);
      setIsPM(parseInt(value.split(':')[0]) >= 12);
    }
  }, [form, name]);

  return (
    <FormField
      className={className}
      control={form.control}
      name={name}
      render={() => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <div className="flex items-center space-x-2">
              <Select
                value={hours.toString()}
                onValueChange={(v) => {
                  setHours(parseInt(v));
                  updateTime(parseInt(v), minutes, isPM);
                }}
              >
                <SelectTrigger className="w-[80px]">
                  <SelectValue placeholder="HH" />
                </SelectTrigger>
                <SelectContent>
                  {Array.from({ length: 12 }, (_, i) => i + 1).map((h) => (
                    <SelectItem key={h} value={h.toString()}>
                      {h.toString().padStart(2, '0')}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <span>:</span>
              <Select
                value={minutes}
                onValueChange={(v) => {
                  setMinutes(v);
                  updateTime(hours, v, isPM);
                }}
              >
                <SelectTrigger className="w-[80px]">
                  <SelectValue placeholder="MM" />
                </SelectTrigger>
                <SelectContent>
                  {Array.from({ length: 4 }, (_, i) => i * 15).map((m) => (
                    <SelectItem key={m} value={m.toString().padStart(2, '0')}>
                      {m.toString().padStart(2, '0')}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <div className="flex items-center space-x-2">
                <Switch
                  checked={isPM}
                  onCheckedChange={(checked) => {
                    setIsPM(checked);
                    updateTime(hours, minutes, checked);
                  }}
                />
                <Label>{isPM ? 'PM' : 'AM'}</Label>
              </div>
            </div>
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
      {...rest}
    />
  );
};

export default TimePicker;
